<p-floatlabel [variant]="variant" class="input-field">
  <p-datepicker
    [formControl]="displayControl"
    (onBlur)="control.markAsTouched()"
    [iconDisplay]="'input'"
    [showIcon]="true"
    [showTime]="true"
    [hourFormat]="hourFormat"
    [stepMinute]="stepMinute"
    [dateFormat]="dateFormat"
    [inputId]="id"
    [fluid]="true"
    [class.ng-invalid]="control.invalid && control.touched"
    [class.ng-dirty]="control.touched"
    (onClose)="closed.emit()"
  />
  @if (hasLabel()) {
    <label [for]="id">{{ label }}</label>
  }
</p-floatlabel>

@if (control.invalid && control.touched) {
  <small class="input-field-error">{{ errorMessage ?? 'This field is required' }}</small>
}
